import App from "./App.vue";
import { createApp } from "vue";
import { createI18n } from 'vue-i18n'
// 引入路由实例
import router from "@/router/index.js";
// 引入Vuex store
import store from "@/store/index.js";
//全局引入lodash
import _ from "lodash";
//全局引入lodash
import dayjs from "dayjs";
// 引入css
import "@/assets/css/base.scss";
//全局引入element-plus组件库，方便修改配置，也可以在vite.config.js中动态引入
import ElementPlus from 'element-plus'
//全局引入element-plus所有图标
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
//引入中英文的数据
import en from './assets/i18n/en.js'
import zh from './assets/i18n/zh.js'
let language = localStorage.getItem("language") || "en"
// 将语言代码转换为i18n使用的格式
let locale = language === 'zh-CN' ? 'zh' : 'en'
const i18n = createI18n({
  // something vue-i18n options here ...
  locale: locale,   // 设置默认的语音版本语言
  messages: {
    zh: { ...zh },
    en: { ...en },
  }
})
// Plugins
import vuetify from '@/plugins/vuetify.js'
// 引入tailwind
import './assets/css/Tailwind.css'
import VxeUITable from 'vxe-table'
import 'vxe-table/lib/style.css'
const app = createApp(App);
i18n.install(app) // use不生效，install生效
for (let key in ElementPlusIconsVue) {
  app.component(key, ElementPlusIconsVue[key])
}
app.config.globalProperties.$_ = _; //挂载到app实例上
app.config.globalProperties.$dayjs = dayjs; //挂载到app实例上
app.use(ElementPlus, { zIndex: 3000 })
  .use(vuetify) //vuetify
  .use(router) //路由
  .use(store) //Vuex store
  .use(VxeUITable) //vxe-table
  .mount("#app");
